module.exports = __webpack_public_path__ + "static/media/no_scan_image.705d94d7.jpg";